import { Component } from '@angular/core';

@Component({
  selector: 'app-company-select',
  template: '<div class="p-4 bg-red-500 text-white">COMPANY SELECT DZIAŁA!</div>',
  standalone: false
})
export class CompanySelectComponent {
  constructor() {
    console.log('CompanySelectComponent constructor called - SIMPLE VERSION');
  }
}
